import { FunctionGroupingArrayByKey } from "radium-omnibus";

const BasketCalculatePrice = (
  form,
  cart,
  sameDayService,
  sameDayServicePrice
) => {
  try {
    const MAIN_PACKAGE = cart?.filter((item) => item?.type === "PACKAGE");
    const ADDONS = cart?.filter((item) => item?.type !== "PACKAGE");
    const DATA_ADDON_GROUP = FunctionGroupingArrayByKey(ADDONS, "master_id");
    let WATER_DATA = null;
    let WATER_PRICE = 0;

    const hasWater = cart?.filter((item) => item?.type === "WATER");

    if (hasWater?.length > 0) {
      WATER_DATA = hasWater[0];
      WATER_PRICE = hasWater[0]?.price;
    }

    const MERGE_DATA = MAIN_PACKAGE?.map((item) => {
      const findSelfAddons =
        DATA_ADDON_GROUP?.find((addon) => {
          return addon?.key === item?.master_id;
        }) || [];
      const addons_price = findSelfAddons?.value?.reduce((a, b) => {
        return (
          a +
          (b?.price
            ? Number(b?.price)
            : Number([b[String(item.size).toLowerCase()]]))
        );
      }, 0);

      const addon_price = Number(addons_price ? addons_price : 0);

      return {
        ...item,
        addons: findSelfAddons?.value || [],
        addons_price: addon_price,
        total_price: Number(item?.price) + addon_price,
      };
    });

    const ONLY_PRICE_OF_PROGRAM = MERGE_DATA?.reduce((a, b) => {
      return a + Number(b?.total_price);
    }, 0);

    if (sameDayService) {
      return (
        Number(ONLY_PRICE_OF_PROGRAM) +
        Number(sameDayServicePrice) +
        WATER_PRICE
      );
    } else {
      return ONLY_PRICE_OF_PROGRAM + WATER_PRICE;
    }
  } catch (error) {
    console.error("BasketCalculatePrice error : ", error);
  }
};

export default BasketCalculatePrice;
